import React from 'react'
import { IProfileItemProps } from '../../../types/IPositionSearchByZoneResponse'
import LabelText from '../../../ui/LabelText'

const PlayerPositionProfile: React.FC<IProfileItemProps> = ({ item }) => {
    return (
        <div className='player-text-data'>
            <LabelText>{item.positionName}</LabelText>
            <LabelText className='player-team-text'>{item.description}</LabelText>
        </div>
    )
}

export default PlayerPositionProfile;
